export default __webpack_public_path__ + "static/media/user-wallet.d0509c32.svg";